import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Popup } from 'react-vant'
import Ripple from '@/components/Ripple'

// 币种类型
export interface Currency {
  icon: string
  name: string
  description: string
  symbol: string
}

// 默认支持的币种列表
export const DEFAULT_CURRENCIES: Currency[] = [
  {
    icon: '/images/home/usdt.png',
    name: 'USDT',
    description: 'Tether USD',
    symbol: 'USDT'
  },
  {
    icon: '/images/home/usdc.png',
    name: 'USDC',
    description: 'USD Coin',
    symbol: 'USDC'
  },
  {
    icon: '/images/home/usd1.png',
    name: 'USD1',
    description: 'USD1',
    symbol: 'USD1'
  }
]

interface CurrencySelectPopupProps {
  visible: boolean
  onClose: () => void
  onSelect: (currency: Currency) => void
  currencies?: Currency[]
  title?: string
}

export default React.memo(function CurrencySelectPopup({
  visible,
  onClose,
  onSelect,
  currencies = DEFAULT_CURRENCIES,
  title
}: CurrencySelectPopupProps) {
  const { t } = useTranslation()
  const [searchText, setSearchText] = useState('')

  // 过滤搜索结果
  const filteredCurrencies = useMemo(() => {
    if (!searchText) return currencies
    return currencies.filter(currency =>
      currency.name.toLowerCase().includes(searchText.toLowerCase()) ||
      currency.description.toLowerCase().includes(searchText.toLowerCase())
    )
  }, [currencies, searchText])

  // 处理选择
  const handleSelect = (currency: Currency) => {
    onSelect(currency)
    setSearchText('') // 清空搜索
    onClose()
  }

  // 关闭时清空搜索
  const handleClose = () => {
    setSearchText('')
    onClose()
  }

  return (
    <Popup
      visible={visible}
      onClose={handleClose}
      position="bottom"
      round
      style={{ height: '80vh' }}
      closeable
      title={title || t('选择币种')}
    >
      <div className="flex flex-col h-full bg-white">
        {/* Header */}
        {/* <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 flex-shrink-0">
          <div className="text-lg font-medium text-gray-900">
            {title || t('选择币种')}
          </div>
          <button
            onClick={handleClose}
            className="w-6 h-6 flex items-center justify-center"
          >
            <img src="/icon/close.svg" alt="close" className="w-4 h-4" />
          </button>
        </div> */}

        {/* Search */}
        <div className="px-6 py-3 flex-shrink-0">
          <div className="flex items-center h-10 bg-[#F3F3F3] rounded-full">
            <div className="w-6 h-6 mr-2 ml-4 flex items-center">
              <img src="/icon/search-icon.svg" alt="search" />
            </div>
            <input
              type="text"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              placeholder={t('搜索')}
              className="flex-1 bg-transparent outline-none text-sm text-black placeholder-[#1A1A1A]/60"
            />
          </div>
        </div>

        {/* 热门标题 */}
        <div className="text-xs text-[#0F0F0F]/60 px-6 py-2 flex-shrink-0">
          {t('热门')}
        </div>

        {/* Currency List */}
        <div className="flex-1 overflow-y-auto px-6 pb-6">
          {filteredCurrencies.length === 0 ? (
            <div className="flex justify-center items-center h-40 text-gray-400">
              {t('暂无数据')}
            </div>
          ) : (
            filteredCurrencies.map((item, index) => (
              <Ripple key={index} className="rounded-2 w-full">
                <div
                  onClick={() => handleSelect(item)}
                  className="w-full flex items-center py-4 cursor-pointer"
                >
                  <div className="flex items-center">
                    <div className="w-7 h-7 mr-3 bg-gray-100 rounded-full flex items-center justify-center overflow-hidden">
                      <img
                        className="w-full h-full object-cover"
                        src={item.icon}
                        alt={item.name}
                      />
                    </div>
                    <div className="text-left">
                      <div className="font-medium text-base text-black">
                        {item.name}
                      </div>
                      <div className="text-xs text-[#727272]">
                        {item.description}
                      </div>
                    </div>
                  </div>
                </div>
              </Ripple>
            ))
          )}
        </div>
      </div>
    </Popup>
  )
})
